// Libs
import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/Option';
import { some, toNumber } from 'lodash/fp';

import { AccessLevel } from '@domui-use-cases/districts/conferences/type';

export type GetAccessLevelsQuery = {
  data: Array<{
    level: AccessLevel;
    targetTermYear?: string | null | undefined;
  }>;
};

export const getIsManagerByYear = (
  accessLevelData: GetAccessLevelsQuery | undefined,
  year: number
) =>
  pipe(
    O.fromNullable(accessLevelData?.data),
    O.map(
      some(
        item =>
          toNumber(item?.targetTermYear) === year &&
          item.level === AccessLevel.Manager
      )
    ),
    O.getOrElse(() => false)
  );
